import { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export function SignInPageInstructionsDialog() {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ zIndex: 9999 }}
    >
      <DialogTitle id="alert-dialog-title">PLEASE READ</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component="div">
          <ul>
            <li>Runway requires two GitHub sign-ins: Enterprise and EMU.</li>
            <li>Click OK to start. Sign in to the provider for the GitHub account you are currently using.</li>
            <li>Then sign in to the other provider (you may need to log out in the pop-up to switch accounts).</li>
            <li>Need help? Slack #runway.</li>
          </ul>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Okay</Button>
      </DialogActions>
    </Dialog>
  );
}
